import { css } from '@compiled/react';
import { defineMessages, useIntl } from 'react-intl';

import { useTheme } from '@/libraries/design/utils/dark-theme-provider';
import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { LogoV2 as Logo } from '@/libraries/wpl/foundations/src/logov2';
import { LogoBrandV2 } from '@/libraries/wpl/foundations/src/logov2';

type LogoLinkContainerProps = {
	logoType?: LogoBrandV2;
};

const logoDarkThemeStyle = css({
	filter: 'brightness(0) invert(1)',
});

// ==================================================================
// Rendering Functions
// ==================================================================
export const LogoLinkContainer = ({ logoType }: LogoLinkContainerProps) => {
	const { isDarkTheme } = useTheme();
	const intl = useIntl();
	const messages = defineMessages({
		ariaLabelLogo: {
			id: 'globalfooterv2.top.logo-label',
			defaultMessage: 'Atlassian logo',
		},
	});

	const localizedHref = useLocalizedHref('/');

	const dataEvent = 'clicked';
	const dataEventComponent = 'linkButton';
	const dataEventContainer = 'globalFooterV2';
	// const dataProductKey = "TO DO: depends on page"

	return (
		<a
			aria-label={intl.formatMessage(messages.ariaLabelLogo)}
			href={localizedHref}
			data-event={dataEvent}
			data-event-component={dataEventComponent}
			data-event-container={dataEventContainer}
		>
			<div css={isDarkTheme && logoDarkThemeStyle}>
				<Logo
					brand={logoType || 'atlassian'}
					type="mark"
					appearance="brand"
					width={32}
					height={32}
				/>
			</div>
		</a>
	);
};
